import Swal from "sweetalert2";
import React, { useState, useEffect } from 'react';
import { Card, Table, Button, Form, Modal, Spinner } from 'react-bootstrap';
import LayoutDashboard from "layouts/layout-dashboard-collapse";
import { postRequest, patchRequest, deleteRequest } from 'services/api';
import dayjs from 'dayjs';
import { getAllMasterKeep } from "./master-keep-api";

const MasterKeepPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({ id: null, name: '' });

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await getAllMasterKeep();
      if (res.success && res.data) {
        setData(res.data);
      } else {
        setData([]);
      }
    } catch (err) {
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleShowModal = (item = null) => {
    if (item) {
      setFormData({ id: item.id, name: item.name });
    } else {
      setFormData({ id: null, name: '' });
    }
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name.trim()) return;

    setIsSubmitting(true);
    try {
      if (formData.id) {
        // Edit
        await patchRequest(`/master-keep/${formData.id}`, { name: formData.name });
        // Simulating success
        setData(prev => prev.map(item => item.id === formData.id ? { ...item, name: formData.name } : item));
      } else {
        // Create
        const res = await postRequest('/master-keep', { name: formData.name });
        if (res.success && res.data) {
          setData(prev => [...prev, res.data]);
        } else {
          Swal.fire("Pemberitahuan", res.message || 'Gagal menyimpan data', "error");
        }
      }
      fetchData(); // Refresh data to get exact UUIDs and fresh data
      setShowModal(false);
    } catch (err) {
      Swal.fire("Pemberitahuan", 'Gagal menyimpan data', "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Apakah Anda yakin ingin menghapus koordinator ini?")) return;
    try {
      const res = await deleteRequest(`/master-keep/${id}`);
      if (res.success) {
        setData(prev => prev.filter(item => item.id !== id));
      } else {
        Swal.fire("Pemberitahuan", res.message || "Gagal menghapus data", "error");
      }
    } catch (err) {
      Swal.fire("Pemberitahuan", "Terjadi kesalahan saat menghapus data", "warning");
    }
  };

  return (
    <LayoutDashboard>
      <div className="container-fluid pt-3 pb-5 mb-5">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h4 className="fw-bold m-0 text-uppercase">MASTER KEEP (KOORDINATOR)</h4>
            <div className="text-muted small mt-1">
              Kelola daftar koordinator / entitas tujuan Keep (misal: JOSH)
            </div>
          </div>
          <Button variant="primary" onClick={() => handleShowModal()}>
            <i className="fe fe-plus me-1"></i> Tambah Baru
          </Button>
        </div>

        <Card className="shadow-sm border-0">
          <Card.Body className="p-0">
            {loading ? (
              <div className="text-center p-5">
                <Spinner animation="border" variant="primary" />
                <div className="mt-2 text-muted">Memuat data...</div>
              </div>
            ) : (
              <Table responsive hover className="m-0 align-middle">
                <thead className="bg-light">
                  <tr>
                    <th className="px-4 py-3" style={{ width: '60px' }}>No</th>
                    <th className="px-4 py-3">Nama Koordinator</th>
                    <th className="px-4 py-3">Tanggal Dibuat</th>
                    <th className="px-4 py-3 text-end" style={{ width: '150px' }}>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? data.map((item, index) => (
                    <tr key={item.id}>
                      <td className="px-4 text-center">{index + 1}</td>
                      <td className="px-4 fw-bold">{item.name}</td>
                      <td className="px-4">{dayjs(item.created_at).format('DD MMM YYYY')}</td>
                      <td className="px-4 text-end">
                        <Button variant="outline-primary" size="sm" className="me-2" onClick={() => handleShowModal(item)}>
                          <i className="fe fe-edit-2"></i>
                        </Button>
                        <Button variant="outline-danger" size="sm" onClick={() => handleDelete(item.id)}>
                          <i className="fe fe-trash-2"></i>
                        </Button>
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan={4} className="text-center py-5 text-muted">
                        Belum ada data koordinator
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            )}
          </Card.Body>
        </Card>

        {/* Modal Form */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Form onSubmit={handleSubmit}>
            <Modal.Header closeButton className="border-0 pb-0">
              <Modal.Title className="fw-bold h5">
                {formData.id ? 'Edit Koordinator' : 'Tambah Koordinator Baru'}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group>
                <Form.Label>Nama Koordinator <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  required
                  placeholder="Misal: JOSH"
                  value={formData.name}
                  onChange={e => setFormData({ ...formData, name: e.target.value })}
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer className="border-0 pt-0">
              <Button variant="secondary" onClick={() => setShowModal(false)}>Batal</Button>
              <Button variant="primary" type="submit" disabled={isSubmitting}>
                {isSubmitting ? <Spinner size="sm" animation="border" /> : 'Simpan'}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

      </div>
    </LayoutDashboard>
  );
};

export default MasterKeepPage;
